import BaseStore from "@/v1/utils/BaseStore";

import {
  GET_CREDENTIALS_START,
  GET_CREDENTIALS_SUCCESS,
  GET_OPERATOR_CASINOS_START,
  GET_OPERATOR_CASINOS_SUCCESS,
  GET_OPERATOR_SETUPS_START,
  GET_OPERATOR_SETUPS_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_START,
  GET_USERS_SUCCESS,
  GET_WHITELISTED_IPS_OPERATORID_START,
  GET_WHITELISTED_IPS_OPERATORID_SUCCESS,
} from "./types";

const initialState = baseState => ({
  ...baseState,
  filters: [
    ...baseState.filters,
    {
      key: "isGateway",
      title: "label.is-gateway",
      icon: "gateway",
      type: "single",
      active: false,
      values: [],
      metadata: [],
    },
  ],
  detail: {
    loading: false,
    isGateway: false,
  },
  whitelistedIps: {
    results: [],
    loading: true,
  },
  casinos: {
    results: [],
    loading: false,
  },
  setups: {
    results: [],
    loading: false,
  },
  credentials: {
    results: [],
    loading: false,
  },
  users: {
    results: [],
    loading: false,
  },
});

const store = new BaseStore("operators", initialState);

const reducer = {
  [GET_OPERATOR_CASINOS_START]: state => ({
    ...state,
    casinos: {
      ...state.casinos,
      loading: true,
    },
  }),
  [GET_OPERATOR_CASINOS_SUCCESS]: (state, payload) => ({
    ...state,
    casinos: {
      ...state.casinos,
      ...payload.casinos,
      loading: false,
    },
  }),
  [GET_OPERATOR_SETUPS_START]: state => ({
    ...state,
    setups: {
      ...state.setups,
      loading: true,
    },
  }),
  [GET_OPERATOR_SETUPS_SUCCESS]: (state, payload) => ({
    ...state,
    setups: {
      ...state.setups,
      results: [...payload.setups],
      loading: false,
    },
  }),
  [GET_CREDENTIALS_START]: state => ({
    ...state,
    credentials: {
      ...state.credentials,
      loading: true,
    },
  }),
  [GET_CREDENTIALS_SUCCESS]: (state, payload) => ({
    ...state,
    credentials: {
      ...state.credentials,
      ...payload.credentials,
      loading: false,
    },
  }),

  [GET_USERS_START]: state => ({
    ...state,
    users: {
      ...state.users,
      loading: true,
    },
  }),
  [GET_USERS_FAIL]: state => ({
    ...state,
    users: {
      ...state.users,
      loading: false,
    },
  }),
  [GET_USERS_SUCCESS]: (state, payload) => ({
    ...state,
    users: {
      ...state.users,
      ...payload.users,
      loading: false,
    },
  }),
  [GET_WHITELISTED_IPS_OPERATORID_START]: (state) => ({
    ...state,
    whitelistedIps: {
      ...state.whitelistedIps,
      results: [],
      loading: true,
    }
  }),
  [GET_WHITELISTED_IPS_OPERATORID_SUCCESS]: (state, payload) => ({
    ...state,
    whitelistedIps: {
      ...state.whitelistedIps,
      results: payload,
      loading: false,
    }
  }),
};

export default store.reducer(reducer);
